import { MultiSelect, MultiSelectProps } from '@mantine/core';

import { useGetTechniquesQuery } from '@api/technique.api';
import { uniqueByName } from '@utils/strings';

export default function TechniqueSelector(props: MultiSelectProps) {
  const { data = [], isLoading } = useGetTechniquesQuery();

  return (
    <MultiSelect
      label="Tecniche utilizzate"
      placeholder={
        props.value && props.value.length !== 0
          ? undefined
          : 'Seleziona le tecniche utilizzate'
      }
      data={uniqueByName(data).map((technique) => ({
        label: technique.name,
        value: technique.name,
      }))}
      disabled={isLoading}
      {...props}
    />
  );
}
